import React from 'react';
import LinkToBox from 'components/dashboard/LinkToBox';
import { localize } from 'react-localize-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-flexbox-grid/lib';
import * as settings from 'settings/settings';
import $ from 'jquery';

import icnImg from 'Content/Assets/images/crashboxx/Instant Crash Alerts.png';
import icnPlusImg from 'Content/Assets/images/crashboxx/Accident Reconstruction.png';
import dentImg from 'Content/Assets/images/crashboxx/Predictive phycsical damage.png';
import biteImg from 'Content/Assets/images/crashboxx/Predictive Bodilyy Injury.png';

class HomePage extends React.Component {

    render() {

        const { translate, currentUserName } = this.props;

        //  check if the user can see the V2 predictivephysicaldamage menu
        const canSeeV2 =
            settings.PredictivePhysicalDamageV2Users &&
            settings.PredictivePhysicalDamageV2Users.some(
                user =>
                    user.toLowerCase() ===
                    (currentUserName || '').toLowerCase()
            );

        return (
            <Row>

                <Col lg={12} md={12} sm={12} xs={12} className="m-b-15">
                    <LinkToBox
                        title={translate('MENU.ICN')}
                        linkTo={"/instantcrashalerts"}
                        icon={icnImg}
                        backGroundColor={'#02ABCA'}
                        body={translate('HOME.InstantCrashAlertsSubTitle')}
                    />
                </Col>

                <Col lg={12} md={12} sm={12} xs={12} className="m-b-15">
                    <LinkToBox
                        title={translate('MENU.ICNPlus')}
                        linkTo={"/accidentreconstruction"}
                        icon={icnPlusImg}
                        backGroundColor={'#48C1D6'}
                        body={translate('HOME.AccidentReconstructionSubTitle')}
                    />
                </Col>

                <Col lg={12} md={12} sm={12} xs={12} className="m-b-15">
                    <LinkToBox
                        title={translate('MENU.dent')}
                        linkTo={"/predictivephysicaldamage"}
                        icon={dentImg}
                        backGroundColor={'#83D5E3'}
                        body={translate('HOME.PredictivePhysicalDamageSubTitle')}
                    />
                </Col>

                {/*  V2 predictivephysicaldamage  visible only for allowed users */}
                {
                    canSeeV2 &&
                    <Col lg={12} md={12} sm={12} xs={12} className="m-b-15">
                        <LinkToBox
                            title={translate('MENU.dentV2')}
                            linkTo={"/predictivephysicaldamage?v=2"}
                            icon={dentImg}
                            backGroundColor={'#83D5E3'}
                            body={translate('HOME.PredictivePhysicalDamageSubTitle')}
                        />
                    </Col>
                }

            </Row>
        );
    }
}

function mapStateToProps(state) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        currentUserName: state.user.currentUser.username
    };
}

export default connect(mapStateToProps)(localize(HomePage, 'locale'));



// WEBPACK FOOTER //
// ./src/pages/home/HomePage.js